import React from "react";
import ClassicHeader from "../../Components/Header/ClassicHeader";
import DistributionDetails from "./partials/DistributionDetails";
import { useQuery } from "react-query";
import { getApiData } from "../../Services/apiMethods";

const Distribution = () => {
  const getDistributionData = () => {
    return getApiData("distribution");
  };

  const { isLoading, data, isError, error } = useQuery(
    "distribution",
    getDistributionData
  );

  if (isLoading) {
    return "Loading... PLease wait a moment.";
  }

  if (isError) {
    return error.message;
  }

  console.log(data.data.distribution[0]);

  return (
    <>
      <ClassicHeader
        bgImage={
          process.env.REACT_APP_IMAGE_BASE_URL +
          data.data.distribution[0].bgImage
        }
        blendMode="mix-blend-overlay"
        blendColor="#0F4D8B"
        title="Distribution"
      />
      <DistributionDetails data={data.data.distribution} />
    </>
  );
};

export default Distribution;
